<template>
  <div class="about-us-area ptb-100">
    <div class="container">
      <div class="section-title mw-860">
        <span class="top-title">متعة المشاهدة اليومية</span>
        <h2>استمتع بكل ما تحبه من محتوى ترفيهي ورياضي يومياً</h2>
      </div>

      <div class="row align-items-center">
        <div class="col-lg-6 col-xxl-7">
          <div class="about-img">
            <img src="@/assets/images/about.jpg" alt="about" />
            <div class="affordable">
              <h4>باقات ترفيهية مميزة تبدأ من</h4>
              <h2>$ 9.99</h2>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-xxl-5">
          <div class="about-content">
            <div class="accordion style-two">
              <div
                class="accordion-item"
                v-for="(item, index) in accordionItems"
                :key="index"
                :class="{ active: activeIndex === index }"
              >
                <h2 class="accordion-header">
                  <button
                    class="accordion-button pt-0"
                    type="button"
                    :aria-expanded="activeIndex === index ? 'true' : 'false'"
                    @click="toggleAccordion(index)"
                  >
                    {{ item.title }}
                  </button>
                </h2>
                <div
                  class="accordion-collapse collapse show"
                  v-show="activeIndex === index"
                >
                  <div class="accordion-body">
                    <p>
                      {{ item.body }}
                    </p>
                    <ul class="ps-0 list-unstyled about-list">
                      <li
                        v-for="(listItem, i) in item.list"
                        :key="i"
                        class="d-flex align-items-center"
                      >
                        <i class="ti ti-circle-check"></i>
                        <span>{{ listItem }}</span>
                      </li>
                    </ul>

                    <a href="https://wa.me/447429916178" target="_blank" class="btn">
                      <span class="border-style">اشترك عبر الواتساب الآن</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "PoweringDailyLife",
  setup() {
    const activeIndex = ref<number>(0);

    const toggleAccordion = (index: number) => {
      activeIndex.value = activeIndex.value === index ? -1 : index;
    };

    const accordionItems = [
      {
        title: "بث رياضي مباشر ومستقر",
        body: "تابع كافة الدوريات الكبرى والبطولات العالمية والإقليمية بجودات متعددة تصل إلى 4K، بفضل بنية تحتية قوية تضمن ثبات البث التام.",
        list: [
          "تغطية مباشرة لكافة قنوات beIN SPORTS و VIP",
          "جودات بث متعددة تتناسب مع مختلف سرعات الإنترنت",
          "تحديثات مستمرة لروابط البث الاحتياطية لضمان عدم الانقطاع",
        ],
      },
      {
        title: "أضخم مكتبة أفلام ومسلسلات (VOD)",
        body: "استمتع بآلاف العناوين المترجمة والمدبلجة من أحدث الأفلام والمسلسلات الحصرية من مختلف المنصات العالمية الشهيرة.",
        list: [
          "تحديثات يومية لإضافة أحدث إنتاجات السينما والدراما",
          "إمكانية طلب إضافة محتوى خاص عبر الدعم الفني",
          "تقسيمات ذكية ومصنفة حسب الأنواع والبلدان لسهولة التصفح",
        ],
      },
      {
        title: "دعم لكافة الشاشات والأجهزة الذكية",
        body: "لا يتطلب الأمر أجهزة معقدة؛ يعمل اشتراكنا بسلاسة على كافة التطبيقات المشهورة المتوفرة لشاشتك أو هاتفك المحمول.",
        list: [
          "توافق كامل مع تطبيقات Smart IPTV و DuplexPlay و Smarters",
          "تشغيل فوري وسهل عبر كود Xtream أو ملفات M3U",
          "دعم فني خطوة بخطوة حتى تمام التشغيل على جهازك",
        ],
      },
      {
        title: "ثبات كامل طوال الـ 24 ساعة",
        body: "نعتمد على خوادم ذكية تقوم بتوزيع الأحمال تلقائياً لضمان كفاءة عالية وثبات غير مسبوق حتى في أوقات الذروة والمباريات الجماهيرية.",
        list: [
          "سيرفرات محمية ومدعومة بأنظمة منع التباطؤ",
          "لوحة تحكم مرنة وسريعة في الاستجابة",
          "تجربة مشاهدة عائلية ترفيهية آمنة ومتكاملة",
        ],
      },
    ];

    return {
      activeIndex,
      toggleAccordion,
      accordionItems,
    };
  },
});
</script>